DegradedStateController.$inject = ['$scope'];

function DegradedStateController($scope) {
  $scope.isDisabled = function () {
    try {
      const allDegradedStates = JSON.parse(
        localStorage.getItem('degradedStates'),
      );
      for (const [key, value] of Object.entries(allDegradedStates)) {
        if (!!value) {
          return true;
        }
      }
      return false;
    } catch (e) {
      rollbar.error(
        new Error(
          'error parsing degraded states in local storage for DegradedStateController',
        ),
      );
      return false;
    }
  };
}

export default DegradedStateController;
